import { isServerSide } from "@jti/fe-common";

export interface DeviceAttributes {
  deviceResolution?: string;
  viewportSize?: string;
  devicePixelRatio?: number;
  orientation?: "portrait" | "landscape";
}

const getOrientation = (viewportWidth: number, viewportHeight: number): DeviceAttributes["orientation"] => {
  const fromApi = typeof screen !== "undefined" ? screen.orientation?.type : undefined;
  if (fromApi?.startsWith("portrait")) {
    return "portrait";
  }
  if (fromApi?.startsWith("landscape")) {
    return "landscape";
  }
  return viewportHeight >= viewportWidth ? "portrait" : "landscape";
};

/**
 * Reads screen/viewport metrics from the browser. SSR-safe: returns an empty
 * object when called outside the browser. One-shot per page load — no listeners.
 *
 * `deviceType` is intentionally omitted: NewRelic Browser already records it
 * as a built-in attribute on PageView events.
 */
export const getDeviceAttributes = (): DeviceAttributes => {
  if (isServerSide()) {
    return {};
  }

  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  return {
    deviceResolution: `${window.screen.width}x${window.screen.height}`,
    viewportSize: `${viewportWidth}x${viewportHeight}`,
    devicePixelRatio: window.devicePixelRatio,
    orientation: getOrientation(viewportWidth, viewportHeight),
  };
};
